<template>
  <div class="copyright">
    <h2>版权大厅</h2>
    <p>这里是版权大厅内容</p>
  </div>
</template>

<script>
export default {
  name: 'CopyrightHall'
}
</script>
